import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { useLocation } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import 'current-device';
import store from '../redux/store';
import history from '../redux/history';
import MainTheme from '../styles/MainTheme';
import RouteRenderer from '../components/RouteRenderer';
import { loadInformation } from '../redux/info/infoActions';
import { SnackbarProvider } from 'notistack';
import Notifier from '../components/Notifier';
import Loader from '../components/Loader';
import { makeStyles } from '@material-ui/core';
import ScopedCssBaseline from '@material-ui/core/ScopedCssBaseline/ScopedCssBaseline';
import { ToastContainer } from 'react-toastify';
import strings from '../lang/lang';
import { getEnvConfig } from '../redux/env/envActions';
import ProdSwitcherAttention from '../components/ProdSwitcherAttention';
import ProdModeSessionOutdated from './common/ProdModeSessionOutdated';
import ApiListener from './common/ApiListener';
import { disableProdSwitcher } from '../redux/prodswitcher/prodSwitcherActions';
import { showSuccess } from '../elements/Toasts/toastActions';

const useStyles = makeStyles(() => ({
  success: {
    backgroundColor: 'rgba(51, 114, 157, 0.9)',
  },
  error: {
    backgroundColor: 'rgba(251, 128, 50, 0.9)',
  },
  warning: {
    backgroundColor: 'yellow',
  },
  info: {
    backgroundColor: 'green',
  },
}));

function App(props) {
  useEffect(() => {

    if (window && window.versions) {
      delete window.versions.swaggerUi.version
    }

    //adding google analytics scripts
    getEnvConfig().then((result) => {
      const ga_key = result['GOOGLE_ANALYTICS_KEY'];

      const hasScript1 = document.getElementById('ga_script_1');
      if (!hasScript1) {
        const script1 = document.createElement('script');
        script1.id = 'ga_script_1';
        script1.async = true;
        script1.src = 'https://www.googletagmanager.com/gtag/js?id=' + ga_key;
        document.head.appendChild(script1);
      }

      const hasScript2 = document.getElementById('ga_script_2');
      if (!hasScript2) {
        const script2 = document.createElement('script');
        script2.id = 'ga_script_2';
        script2.type = 'text/javascript';
        script2.innerHTML =
          'window.dataLayer = window.dataLayer || [];\n' +
          '      function gtag() {\n' +
          '        dataLayer.push(arguments);\n' +
          '      }\n' +
          "      gtag('js', new Date());\n" +
          "      gtag('config', '" +
          ga_key +
          "');";
        document.head.appendChild(script2);
      }
    });
  }, []);

  const { pathname } = useLocation();

  useEffect(() => {
    loadInformation({ pathname, section: '/docs/apis' });

    const interval = setInterval(() => {
      var match = document.cookie.match(new RegExp('(^| )prodmode=([^;]+)'));
      if (!match && store.getState().prodSwitcher.isProdSwitcherOpen) {
        disableProdSwitcher();
        showSuccess(strings.liveMode.text.sandboxMode);
      }
    }, 10000);
    return () => clearInterval(interval);
  }, [pathname]);

  strings.setLanguage('en');

  const classes = useStyles();

  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <MainTheme>
          <ProdSwitcherAttention />
          <ProdModeSessionOutdated />
          <ScopedCssBaseline />
          <ToastContainer
            hideProgressBar={false}
            draggable={false}
            closeButton={false}
            closeOnClick={false}
          />
          <SnackbarProvider
            classes={{
              variantSuccess: classes.success,
              variantError: classes.error,
              variantWarning: classes.warning,
              variantInfo: classes.info,
            }}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            maxSnack={5}
            preventDuplicate={true}
            autoHideDuration={3000}
          >
            <React.Fragment>
              <Loader />
              <Notifier>
                <RouteRenderer />
              </Notifier>
              <ApiListener />
            </React.Fragment>
          </SnackbarProvider>
        </MainTheme>
      </ConnectedRouter>
    </Provider>
  );
}

export default App;
